import { createFileRoute, redirect } from "@tanstack/react-router";

// Folded into /conveyancing-sunshine-coast so one page carries the Sunshine Coast conveyancing signal.
export const Route = createFileRoute("/sunshine-coast")({
  beforeLoad: () => {
    throw redirect({ href: "/conveyancing-sunshine-coast", statusCode: 301 });
  },
});
